import React from 'react'

function Team() {
  return (
    <>
  <section className="inner-banner-wrap bg-light-grey">
    <div
      className="inner-baner-container"
      style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
    >
      <div className="container">
        <div className="inner-banner-content">
          <h1 className="inner-title">Team</h1>
        </div>
      </div>
    </div>
  </section>
  {/* Inner Banner html end*/}
  {/* Team html start */}
  <div className="team-page-section">
    <div className="team-page-inner bg-light-grey">
      <div className="container">
        <div className="row">
          <div className="col-md-3 col-sm-6">
            <article className="team-item">
              <figure className="team-img">
                <img src="assets/images/img9.jpg" alt="" />
              </figure>
              <div className="team-content">
                <div className="social-links">
                  <ul>
                    <li>
                      <a href="https://www.facebook.com/" target="_blank">
                        <i className="fab fa-facebook-f" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.twitter.com/" target="_blank">
                        <i className="fab fa-twitter" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/" target="_blank">
                        <i className="fab fa-instagram" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/" target="_blank">
                        <i className="fab fa-youtube" aria-hidden="true" />
                      </a>
                    </li>
                  </ul>
                </div>
                <h4>William Scott</h4>
                <span>Chief Director</span>
              </div>
            </article>
          </div>
          <div className="col-md-3 col-sm-6">
            <article className="team-item">
              <figure className="team-img">
                <img src="assets/images/img10.jpg" alt="" />
              </figure>
              <div className="team-content">
                <div className="social-links">
                  <ul>
                    <li>
                      <a href="https://www.facebook.com/" target="_blank">
                        <i className="fab fa-facebook-f" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.twitter.com/" target="_blank">
                        <i className="fab fa-twitter" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/" target="_blank">
                        <i className="fab fa-instagram" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/" target="_blank">
                        <i className="fab fa-youtube" aria-hidden="true" />
                      </a>
                    </li>
                  </ul>
                </div>
                <h4>Alison Brown</h4>
                <span>Head Manager</span>
              </div>
            </article>
          </div>
          <div className="col-md-3 col-sm-6">
            <article className="team-item">
              <figure className="team-img">
                <img src="assets/images/img11.jpg" alt="" />
              </figure>
              <div className="team-content">
                <div className="social-links">
                  <ul>
                    <li>
                      <a href="https://www.facebook.com/" target="_blank">
                        <i className="fab fa-facebook-f" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.twitter.com/" target="_blank">
                        <i className="fab fa-twitter" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/" target="_blank">
                        <i className="fab fa-instagram" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/" target="_blank">
                        <i className="fab fa-youtube" aria-hidden="true" />
                      </a>
                    </li>
                  </ul>
                </div>
                <h4>Adam Henry</h4>
                <span>Supervisor</span>
              </div>
            </article>
          </div>
          <div className="col-md-3 col-sm-6">
            <article className="team-item">
              <figure className="team-img">
                <img src="assets/images/img12.jpg" alt="" />
              </figure>
              <div className="team-content">
                <div className="social-links">
                  <ul>
                    <li>
                      <a href="https://www.facebook.com/" target="_blank">
                        <i className="fab fa-facebook-f" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.twitter.com/" target="_blank">
                        <i className="fab fa-twitter" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/" target="_blank">
                        <i className="fab fa-instagram" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/" target="_blank">
                        <i className="fab fa-youtube" aria-hidden="true" />
                      </a>
                    </li>
                  </ul>
                </div>
                <h4>Sally Watson</h4>
                <span>Chief Advisor</span>
              </div>
            </article>
          </div>
          <div className="col-md-3 col-sm-6">
            <article className="team-item">
              <figure className="team-img">
                <img src="assets/images/img30.jpg" alt="" />
              </figure>
              <div className="team-content">
                <div className="social-links">
                  <ul>
                    <li>
                      <a href="https://www.facebook.com/" target="_blank">
                        <i className="fab fa-facebook-f" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.twitter.com/" target="_blank">
                        <i className="fab fa-twitter" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/" target="_blank">
                        <i className="fab fa-instagram" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/" target="_blank">
                        <i className="fab fa-youtube" aria-hidden="true" />
                      </a>
                    </li>
                  </ul>
                </div>
                <h4>Jenny White</h4>
                <span>Chief Director</span>
              </div>
            </article>
          </div>
          <div className="col-md-3 col-sm-6">
            <article className="team-item">
              <figure className="team-img">
                <img src="assets/images/img31.jpg" alt="" />
              </figure>
              <div className="team-content">
                <div className="social-links">
                  <ul>
                    <li>
                      <a href="https://www.facebook.com/" target="_blank">
                        <i className="fab fa-facebook-f" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.twitter.com/" target="_blank">
                        <i className="fab fa-twitter" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/" target="_blank">
                        <i className="fab fa-instagram" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/" target="_blank">
                        <i className="fab fa-youtube" aria-hidden="true" />
                      </a>
                    </li>
                  </ul>
                </div>
                <h4>George Smith</h4>
                <span>Head Manager</span>
              </div>
            </article>
          </div>
          <div className="col-md-3 col-sm-6">
            <article className="team-item">
              <figure className="team-img">
                <img src="assets/images/img32.jpg" alt="" />
              </figure>
              <div className="team-content">
                <div className="social-links">
                  <ul>
                    <li>
                      <a href="https://www.facebook.com/" target="_blank">
                        <i className="fab fa-facebook-f" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.twitter.com/" target="_blank">
                        <i className="fab fa-twitter" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/" target="_blank">
                        <i className="fab fa-instagram" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/" target="_blank">
                        <i className="fab fa-youtube" aria-hidden="true" />
                      </a>
                    </li>
                  </ul>
                </div>
                <h4>Scarlet Winston</h4>
                <span>Supervisor</span>
              </div>
            </article>
          </div>
          <div className="col-md-3 col-sm-6">
            <article className="team-item">
              <figure className="team-img">
                <img src="assets/images/img33.jpg" alt="" />
              </figure>
              <div className="team-content">
                <div className="social-links">
                  <ul>
                    <li>
                      <a href="https://www.facebook.com/" target="_blank">
                        <i className="fab fa-facebook-f" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.twitter.com/" target="_blank">
                        <i className="fab fa-twitter" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/" target="_blank">
                        <i className="fab fa-instagram" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/" target="_blank">
                        <i className="fab fa-youtube" aria-hidden="true" />
                      </a>
                    </li>
                  </ul>
                </div>
                <h4>Jack Wilson</h4>
                <span>Chief Advisor</span>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
    <div className="team-support-details">
      <div className="container">
        <div className="inner-support-details">
          <div
            className="inner-support-image"
            style={{ backgroundImage: "url(assets/images/img8.jpg)" }}
          ></div>
          <div className="inner-support-content">
            <div className="title-divider" />
            <h3>
              Do You Need Best Help For Business Corporating Related Issues !
            </h3>
            <div className="support-btn-wrap d-flex flex-wrap align-items-center justify-content-between">
              <a href="contact.html" className="button-round">
                Free Consultation
              </a>
              <div className="d-flex flex-wrap">
                <div className="support-number-icon">
                  <i aria-hidden="true" className="icon icon-phone" />
                </div>
                <div className="support-number-content">
                  <h5>24/7 HOUR AVAILABLE</h5>
                  <a href="telto:91125927357">+(911) 259 273 57</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</>

  )
}

export default Team